import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import ErrorPage from 'components/CreatorStoreFront/ErrorPage/ErrorPage';

const CSFErrorPage = () => <ErrorPage />;

export default wrapFunctionalComponent(CSFErrorPage, 'CSFErrorPage');
